module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.error.message) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v(_vm._s(_vm.error.message))]), _c('br'), _vm._v("\n          Bitte die Zugangsdaten prüfen.\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Benutzer")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    ref: "username",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "login-username",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Passwort")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "login-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c3d5d88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/login.vue
// module id = 118
// module chunks = 1